import { featurePageAlternateLinks } from "@/features/feature-page/feature-page-alternate-links";
import { featurePageSocialImage } from "@/features/feature-page/feature-page-social-image";
import { withSiteTitle } from "@/lib/page-title";
import { buildSeoMetaTags } from "@/lib/seo-meta";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export function buildFeaturePageHead(
  page: FeaturePageRenderModel | null | undefined,
  options: { hasDirectoryVariants?: boolean; robots?: string } = {},
) {
  if (!page) return { meta: [{ title: withSiteTitle("Editorial") }] };
  const socialImage = featurePageSocialImage(page);
  return {
    meta: buildSeoMetaTags(
      {
        title: page.seo.title,
        description: page.seo.description,
        socialTitle: page.seo.socialTitle,
        socialDescription: page.seo.socialDescription,
        canonicalUrl: page.seo.canonicalUrl,
        imageUrl: socialImage.imageUrl,
      },
      {
        robots:
          options.robots ?? (options.hasDirectoryVariants ? "noindex,follow" : page.seo.robots),
        openGraph: {
          type: page.page.family === "story" ? "article" : "website",
          image: socialImage.image,
        },
        twitter: { card: "summary_large_image" },
      },
    ),
    links: [
      { rel: "canonical", href: page.seo.canonicalUrl },
      ...featurePageAlternateLinks(page.seo.alternates),
    ],
  };
}
